// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NoticeComponents .notice-swipe[data-v-6fcee4e6]{height:40px;line-height:40px}.NoticeComponents .van-notice-bar[data-v-6fcee4e6]{padding:0 .5rem}.NoticeComponents[data-v-6fcee4e6] .van-icon__image{width:1.4rem;height:1.4rem;-o-object-fit:contain;object-fit:contain;margin-right:.5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
